import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';

import { useStore } from 'core/store/';
import AutoBundleSelect from 'common/components/farm/auto-bundle-select';

/**
 * #30919: offer-sidebar control for the farm Auto/Home bundle discount. Replaces the old yes/no
 * add-remove row with a dropdown so staff can record an auto policy with a carrier OTHER than
 * BIX (rater level 2), not just "has an auto policy" (level 1). Writes both Formik fields via the
 * shared AutoBundleSelect and mirrors the change into the offer store so the discounts card badge
 * and re-rate override logic stay in sync.
 */
const AutoHomeBundleDiscount = observer(({ label, disabled }) => {
  const { offer: store } = useStore();

  const onAfterChange = useCallback(
    (bundleOn, carrier) => {
      store.setIncludeMultiPolicyDiscount(bundleOn);
      store.setAutoBundleCarrier(carrier);
    },
    [store]
  );

  return (
    <Grid container>
      <AutoBundleSelect
        label={label || 'Auto/Home Bundle'}
        mode="dark"
        disabled={disabled}
        onAfterChange={onAfterChange}
      />
    </Grid>
  );
});

export default AutoHomeBundleDiscount;
